import React from 'react';
import { useSystemStatus } from '../../contexts/SystemStatusContext';
import { AlertTriangle, Info } from 'lucide-react';

const StatusBanner = () => {
    const { status, message, isLoading } = useSystemStatus();

    if (isLoading || status === 'normal') {
        return null;
    }

    const bannerConfig = {
        outage: {
            bgColor: 'bg-red-500',
            textColor: 'text-white',
            Icon: AlertTriangle,
            defaultMessage: '現在、システム障害が発生しています。',
        },
        maintenance: {
            bgColor: 'bg-yellow-400',
            textColor: 'text-gray-800',
            Icon: Info,
            defaultMessage: '現在、メンテナンスを実施しています。',
        },
    };

    const config = bannerConfig[status];

    if (!config) {
        return null;
    }

    const displayMessage = message || config.defaultMessage;

    return (
        <div className={`${config.bgColor} ${config.textColor} w-full py-2 px-4 text-sm`}>
            <div className="max-w-7xl mx-auto flex items-center justify-center">
                <config.Icon size={18} className="mr-3 flex-shrink-0" />
                <span className="font-semibold">{displayMessage}</span>
            </div>
        </div>
    );
};

export default StatusBanner;
